<span *ngIf="!isLink && !isInnerHtml" class="{{className}}" [matTooltip]="tooltipText" (click)="textClick()">{{text}}</span>

<a *ngIf="isLink" routerLink="{{link}}" routerLinkActive="active"><span class="{{className}}" [matTooltip]="tooltipText" >{{text}}</span></a>

<span *ngIf="!isLink && isInnerHtml" class="{{className}}" (click)="textClick()" [innerHtml]="text" [matTooltip]="tooltipText"></span>